import React from 'react';
import Icon from 'components/lib/icons/icon';

export default props => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M8 14V5m0 0l2.5 3M8 5L5.5 8M2 2h12" strokeLinecap="round" strokeLinejoin="round" />
  </Icon>
);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/upload_csv_icon.jsx